import React from "react"

/* importing custom modules */
import ContactForm from '../Material-UI-Components/Contact-From'
import Badge from '../Material-UI-Components/Badge';

export default function CareerCounseling(){

  const [floatingContactForm, setFloatingContactForm] = React.useState();


  const handleFloatingContactForm = (value) =>{
    setFloatingContactForm(value);
  };

  return(
    <div>
    {floatingContactForm?
        <div>
          <div className="floatingContactForm">
            <div className="width100 mgbt40">
              <ContactForm/>
            </div>
          </div>
        </div>
        :
    <div></div>}
          <div className="floatingQueryFormButton">
            <Badge 
                type={'floatingIcon'} 
                badgeContent={'Contact-us'}
                handleFloatingContactForm={handleFloatingContactForm}
                floatingContactForm = {floatingContactForm}
            />
          </div> 
  </div>
)
}